import { Component, ElementRef, ViewChild } from '@angular/core';
import { ModalController, ViewWillEnter, ViewWillLeave } from '@ionic/angular';

import jsQR from 'jsqr';

import { ModalRoleEnum } from '../../enums/modal-role.enum';

@Component({
    selector: 'app-qr-scanner-dialog',
    templateUrl: './qr-scanner-dialog.component.html',
    styleUrls: ['./qr-scanner-dialog.component.scss']
})
export class QrScannerDialogComponent implements ViewWillEnter, ViewWillLeave {
    @ViewChild('videoElement', { static: false }) videoElement: ElementRef;
    @ViewChild('canvasElement', { static: false }) canvasElement: ElementRef;

    scannedData: string;
    videoStream: MediaStream;
    isScanning: boolean = false;

    constructor(
        private modalCtrl: ModalController
    ) { }

    ionViewWillEnter(): void {
        this.startScanner();
    }

    ionViewWillLeave(): void {
        this.stopScanner();
    }

    startScanner() {

        const video: HTMLVideoElement = this.videoElement.nativeElement;
        const canvas: HTMLCanvasElement = this.canvasElement.nativeElement;
        const context = canvas.getContext('2d');

        navigator.mediaDevices
            .getUserMedia({ video: { facingMode: 'environment', width: { min: 250, max: 450, ideal: 400 }, height: { min: 250, max: 450, ideal: 400 } } })
            .then((stream) => {
                video.srcObject = stream;
                video.setAttribute('playsinline', 'true');
                video.play();
                this.videoStream = stream;
                this.isScanning = true;

                requestAnimationFrame(tick);
            });

        const tick = () => {
            if (this.isScanning && video.readyState === video.HAVE_ENOUGH_DATA) {
                canvas.height = video.videoHeight;
                canvas.width = video.videoWidth;
                context.drawImage(video, 0, 0, canvas.width, canvas.height);

                const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, canvas.width, canvas.height);

                if (code) {
                    this.scannedData = code.data;
                    this.isScanning = false;
                    this.stopScanner();
                    this.confirm();
        }
            }

            if (this.isScanning) {
                requestAnimationFrame(tick);
            }
        };
    }

    stopScanner() {
        if (this.videoStream) {
            const tracks = this.videoStream.getTracks();
            tracks.forEach((track) => track.stop());
        }
    }

    async confirm() {
        const dataClose = new QrScannerDialogDataClose(this.scannedData);

        await this.modalCtrl.dismiss(dataClose, ModalRoleEnum.CONFIRM);
    }

    async dismiss() {
        await this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
    }
}

export class QrScannerDialogDataClose {
    constructor(
        public scannedData: any
    ) { }
}
